let helper = require('./helper');
// let ads = require('./ads');

module.exports = {
    isInited: false,
    init: function (dfpEvent) {
        if(this.isInited) return;
        this.isInited = true;
        let that = this;

        let adPlacement = this.getAdPlacement(dfpEvent);
        // let creativeHeight = (dfpEvent.size) ? dfpEvent.size[1] : undefined;
        let creativeHeight = this.getHeightOfRenderedUnit(dfpEvent);
        helper.addClass(adPlacement, 'fixed-footer');
        if(creativeHeight) adPlacement.style.height = creativeHeight+'px';
        let closeBtn = document.createElement('i'); closeBtn.className = 'close-footer';
        helper.addEvent(closeBtn, 'click', () => {
            that.hide(undefined, adPlacement);
            // helper.addClass(adPlacement, 'fixed-footer-closed');
            // helper.removeClass(document.body, 'footer-widget-is-visible');
        });
        adPlacement.appendChild(closeBtn);
        this.fixIssueOnFacebookInAppBrowser(adPlacement);
    },
    show: function (dfpEvent) {
        let adPlacement = this.getAdPlacement(dfpEvent);
        // let creativeHeight = (dfpEvent.size) ? dfpEvent.size[1] : undefined;

        this.updateHeight(dfpEvent, adPlacement);

        helper.removeClass(adPlacement, 'fixed-footer-closed');
        helper.addClass(adPlacement, 'fixed-footer-opened');
        helper.addClass(document.body, 'footer-widget-is-visible');

    },
    hide: function (dfpEvent, adPlacement) {
        if(!adPlacement) {
            adPlacement = this.getAdPlacement(dfpEvent);
        }
        helper.removeClass(adPlacement, 'fixed-footer-opened');
        helper.removeClass(document.body, 'footer-widget-is-visible');
        if(window.updateFooterHeightTimer) clearInterval(window.updateFooterHeightTimer);
    },
    updateHeight: function (dfpEvent, adPlacement) {
        if(!adPlacement) {
            adPlacement = this.getAdPlacement(dfpEvent);
        }
        let creativeHeight = this.getHeightOfRenderedUnit(dfpEvent);
        if(creativeHeight) adPlacement.style.height = creativeHeight+'px';
    },
    getAdPlacement: function (dfpEvent) {
        let slot = dfpEvent.slot;
        let slotElementId = slot.getSlotElementId();
        let slotElement = document.getElementById(slotElementId);
        let adPlacement = slotElement.parentNode;
        return adPlacement;
    },
    fixIssueOnFacebookInAppBrowser: function (footer) {
        if(helper.isFacebookApp()){
            let callback = function () {
                if(footer.className.indexOf('fixed-footer-opened') > -1){
                    let footerHeight = footer.offsetHeight;
                    let windowHeight = window.innerHeight;
                    let topToSet = windowHeight - footerHeight;
                    footer.style.top = topToSet + 'px';
                    footer.style.bottom = 'initial';
                }
            };
            callback();
            helper.addEvent(window, 'resize', callback);
            setInterval(callback,  1000);
        }
    },
    getHeightOfRenderedUnit: function(dfpEvent) {
        // Is has duplicate in ads.js
        return document.getElementById(dfpEvent.slot.getSlotElementId()).querySelector('iframe').offsetHeight;
    }
};